export default {
  text: 'Verify with {{provider}}',
  text_generic: 'Verify with your payment provider',
  error: 'We could not open the {{provider}} form. Please try again.',
  error_generic: 'We could not open the payment provider form. Please try again.',
  providers: {
    stripe: 'Stripe',
    adyen: 'Adyen',
  },
};
